import { apiClient } from '@/api/axios';
import type { ApiResponse } from '@/types/api';
import type {
  AuthTokens,
  ContinueAuthRequest,
  ContinueAuthResponse,
  CreatePinRequest,
  LoginRequest,
  RegisterRequest,
  RegisterResponse,
  ValidateTokenResponse,
} from '@/types/auth';

const AUTH_BASE = '/api/auth';

export const authService = {
  async login(payload: LoginRequest): Promise<AuthTokens> {
    const { data } = await apiClient.post<ApiResponse<AuthTokens>>(`${AUTH_BASE}/login`, payload);
    return data.data;
  },

  async continueWithEmail(payload: ContinueAuthRequest): Promise<ContinueAuthResponse> {
    const { data } = await apiClient.post<ApiResponse<ContinueAuthResponse>>(
      `${AUTH_BASE}/continue`,
      payload,
    );
    return data.data;
  },

  async register(payload: RegisterRequest): Promise<RegisterResponse> {
    const { data } = await apiClient.post<ApiResponse<RegisterResponse>>(
      `${AUTH_BASE}/register`,
      payload,
    );
    return data.data;
  },

  async validateToken(token: string): Promise<ValidateTokenResponse> {
    const { data } = await apiClient.get<ApiResponse<ValidateTokenResponse>>(
      `${AUTH_BASE}/validate-token`,
      { params: { token } },
    );
    return data.data;
  },

  async createPin(payload: CreatePinRequest): Promise<AuthTokens> {
    const { data } = await apiClient.post<ApiResponse<AuthTokens>>(`${AUTH_BASE}/create-pin`, payload);
    return data.data;
  },

  async forgotPin(payload: { email: string }): Promise<{ message: string }> {
    const { data } = await apiClient.post<ApiResponse<{ message: string }>>(
      `${AUTH_BASE}/forgot-pin`,
      payload,
    );
    return data.data;
  },

  async getTaskListColumns(): Promise<{ columns: string[] | null }> {
    const { data } = await apiClient.get<ApiResponse<{ columns: string[] | null }>>(
      `${AUTH_BASE}/preferences/task-list-columns`,
    );
    return data.data;
  },

  async updateTaskListColumns(columns: string[]): Promise<{ columns: string[] }> {
    const { data } = await apiClient.put<ApiResponse<{ columns: string[] }>>(
      `${AUTH_BASE}/preferences/task-list-columns`,
      { columns },
    );
    return data.data;
  },

  async logout(): Promise<void> {
    const refreshToken = localStorage.getItem('cg_refresh_token');
    if (refreshToken) {
      await apiClient.post(`${AUTH_BASE}/logout`, { refreshToken });
    }
  },
};
